(function() {
  let mdSelectedVariantId = null;
  let mdCurrent = 0;

  function mdPreventNav(e) {
    if (e && typeof e.preventDefault === 'function') {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  function mdGetCartElement() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function mdOpenCartDrawer(cartData, triggerEl) {
    if (typeof window.SLIDECART_UPDATE === 'function') {
      window.SLIDECART_UPDATE(cartData);
    }
    if (typeof window.SLIDECART_OPEN === 'function') {
      window.SLIDECART_OPEN();
      return true;
    }

    const cart = mdGetCartElement();
    if (cart && typeof cart.renderContents === 'function' && cartData && cartData.sections) {
      cart.classList.remove('is-empty');
      if (triggerEl && typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(triggerEl);
      }
      cart.renderContents(cartData);
      return true;
    }

    return false;
  }

  async function mdAddVariant(variantId, triggerEl, clickEvent) {
    mdPreventNav(clickEvent);

    const btn = triggerEl || (clickEvent && clickEvent.currentTarget) || (typeof event !== 'undefined' && event && event.currentTarget) || null;
    const orig = btn ? btn.textContent : '';
    if (btn) {
      btn.textContent = 'Adding…';
      btn.disabled = true;
    }

    const cartAddUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      ? window.Shopify.routes.root + 'cart/add.js'
      : '/cart/add.js';

    try {
      const res = await fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1
        })
      });

      const data = await res.json();

      if (!res.ok || data.status) {
        throw new Error(data.description || data.message || 'Cart error');
      }

      mdOpenCartDrawer(data, btn);

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'skin-reset', cartData: data });
      }

      if (btn) {
        btn.textContent = 'Added ✓';
        setTimeout(function() { btn.textContent = orig; btn.disabled = false; }, 2000);
      }
    } catch (e) {
      console.error('Skin reset add to cart failed:', e);
      if (btn) {
        btn.textContent = 'Try again';
        btn.disabled = false;
        setTimeout(function() { btn.textContent = orig; }, 2000);
      }
    }
  }

  window.mdAddVariant = function(variantId, triggerEl, clickEvent) {
    return mdAddVariant(
      variantId,
      triggerEl,
      clickEvent || (typeof event !== 'undefined' ? event : null)
    );
  };

  window.mdAddToCart = function(clickEvent) {
    mdPreventNav(clickEvent || (typeof event !== 'undefined' ? event : null));
    if (mdSelectedVariantId) {
      const btn = document.getElementById('hero-cta');
      return mdAddVariant(mdSelectedVariantId, btn, clickEvent || (typeof event !== 'undefined' ? event : null));
    }
  };

  function fmtFromShopifyPrice(cents) {
    if (!cents) return '';
    var amount = Number(cents) / 100;
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents);
    }
    return '₹' + Math.round(amount).toLocaleString('en-IN');
  }

  window.selectKit = function(el) {
    if (!el || el.classList.contains('kit-option--soldout')) return;

    const price = parseInt(el.dataset.price, 10) || 0;
    const compare = parseInt(el.dataset.compare, 10) || 0;
    const variantId = el.dataset.variantId;
    mdSelectedVariantId = variantId;

    document.querySelectorAll('.kit-option').forEach(function(o) {
      o.classList.remove('active');
    });
    el.classList.add('active');

    const savePct = compare > price ? Math.round((compare - price) / compare * 100) : 0;
    const priceEl = document.getElementById('hero-price');
    const mrpEl = document.getElementById('hero-mrp');
    const saveEl = document.getElementById('hero-save');
    const ctaEl = document.getElementById('hero-cta');

    if (priceEl) priceEl.textContent = fmtFromShopifyPrice(price);
    if (mrpEl) {
      if (savePct > 0) {
        mrpEl.textContent = fmtFromShopifyPrice(compare);
        mrpEl.style.display = '';
      } else {
        mrpEl.style.display = 'none';
      }
    }
    if (saveEl) saveEl.textContent = savePct > 0 ? 'Save ' + savePct + '%' : 'Best Price';
    if (ctaEl) {
      var prefix = 'Add to Cart —';
      var kitSelector = document.querySelector('.kit-selector');
      if (kitSelector && kitSelector.dataset.ctaPrefix) {
        prefix = kitSelector.dataset.ctaPrefix;
      }
      ctaEl.textContent = prefix + ' ' + fmtFromShopifyPrice(price);
    }
  };

  window.mdGoTo = function(index) {
    const mdTrack = document.getElementById('mdTrack');
    const mdDots = document.getElementById('mdDots');
    const mdThumbs = document.getElementById('mdThumbs');
    if (!mdTrack) return;
    const slides = mdTrack.querySelectorAll('.hc-slide');
    if (!slides.length) return;
    mdCurrent = (index + slides.length) % slides.length;
    mdTrack.style.transform = 'translateX(-' + (mdCurrent * 100) + '%)';
    if (mdDots) {
      mdDots.querySelectorAll('.hc-dot').forEach(function(d, i) {
        d.classList.toggle('active', i === mdCurrent);
      });
    }
    if (mdThumbs) {
      const thumbs = mdThumbs.querySelectorAll('.hc-thumb');
      thumbs.forEach(function(t, i) {
        t.classList.toggle('active', i === mdCurrent);
      });
      if (thumbs[mdCurrent]) {
        thumbs[mdCurrent].scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
      }
    }
  };

  window.mdSlide = function(dir) {
    window.mdGoTo(mdCurrent + dir);
  };

  window.toggleHeroReadMore = function() {
    const content = document.getElementById('hero-rm-content');
    const btn = document.getElementById('hero-rm-btn');
    const chevron = document.getElementById('hero-rm-chevron');
    if (!content || !btn) return;
    const isOpen = content.classList.contains('open');
    content.classList.toggle('open', !isOpen);
    if (chevron) chevron.style.transform = isOpen ? '' : 'rotate(180deg)';
    btn.childNodes[0].textContent = isOpen ? 'Read more ' : 'Read less ';
  };

  window.togglePhilosophy = function() {
    const btn = document.getElementById('phil-btn');
    const body = document.getElementById('phil-body');
    const label = document.getElementById('phil-btn-label');
    if (!btn || !body) return;
    const isOpen = body.classList.contains('open');
    body.classList.toggle('open', !isOpen);
    btn.classList.toggle('open', !isOpen);
    btn.setAttribute('aria-expanded', String(!isOpen));
    if (label) label.textContent = isOpen ? 'Explore the science' : 'Close';
  };

  window.switchPhase = function(num) {
    document.querySelectorAll('.phase-tab-btn').forEach(function(btn) {
      const phase = parseInt(btn.dataset.phase, 10);
      btn.classList.toggle('active', phase === num);
      btn.setAttribute('aria-selected', String(phase === num));
    });
    document.querySelectorAll('.phase-panel').forEach(function(panel) {
      panel.classList.toggle('active', panel.id === 'panel-' + num);
    });
  };

  window.toggleFAQ = function(btn) {
    const item = btn.closest('.faq-item');
    if (item) item.classList.toggle('open');
  };

  window.toggleReadMore = function(btn) {
    const content = btn.nextElementSibling;
    if (!content) return;
    const isOpen = content.classList.contains('open');
    content.classList.toggle('open');
    const chevron = btn.querySelector('svg');
    if (chevron) chevron.style.transform = isOpen ? 'rotate(0deg)' : 'rotate(180deg)';
    btn.childNodes[0].textContent = isOpen ? 'Read more' : 'Read less';
  };

  window.mdjGoTo = function(id, el) {
    document.querySelectorAll('.mdj-panel').forEach(function(panel) {
      panel.classList.remove('active');
    });
    const target = document.getElementById('mdj-' + id);
    if (target) target.classList.add('active');
    document.querySelectorAll('.mdj-tab').forEach(function(tab) {
      tab.classList.remove('active');
    });
    if (el) el.classList.add('active');
  };

  window.toggleSlide9xA = function() {
    const el = document.querySelector('.scistudies-hidden-9xA');
    const btn = document.querySelector('.scistudies-toggle-9xA');
    if (!el || !btn) return;
    const isOpen = el.classList.contains('open-9xA');
    if (isOpen) {
      el.style.height = el.scrollHeight + 'px';
      requestAnimationFrame(function() {
        el.style.height = '0px';
      });
      el.classList.remove('open-9xA');
      btn.textContent = 'See More';
    } else {
      el.style.height = el.scrollHeight + 'px';
      el.classList.add('open-9xA');
      btn.textContent = 'See Less';
      el.addEventListener('transitionend', function handler() {
        if (el.classList.contains('open-9xA')) {
          el.style.height = 'auto';
        }
        el.removeEventListener('transitionend', handler);
      });
    }
  };

  document.addEventListener('DOMContentLoaded', function() {
    const defaultKit = document.querySelector('.kit-option.active') || document.querySelector('.kit-option');
    if (defaultKit) {
      window.selectKit(defaultKit);
    }

    const carousel = document.getElementById('mdCarousel');
    if (carousel) {
      let sx = 0;
      carousel.addEventListener('touchstart', function(e) {
        sx = e.touches[0].clientX;
      }, { passive: true });
      carousel.addEventListener('touchend', function(e) {
        const dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) window.mdSlide(dx < 0 ? 1 : -1);
      }, { passive: true });
    }
  });
})();
